export const BASE_URL = 'https://www.doortodoorbeauty.com/api'
// export const BASE_URL = '/api'
// export const BASE_URL = 'http://127.0.0.1:8000/api'

// https://www.doortodoorbeauty.com/api/master/products/search/?q=Fruit%20Facial
export const SEARCH_URL = '/master/products/search/'

export const CATEGORY_URL = '/master/category/create/list/'
export const LOCATION_URL = '/master/location/create/list/'
export const OURTEAM_URL = '/master/our-team/create/list/'
export const OURTEAM_DETAIL_URL = '/management/our-team/detail/'

export const PRODUCT_BY_CATEGORY_URL = '/master/items/create/list/'
export const SINGLEPRODUCT_URL = '/master/items/detail/'
export const BLOG_URL = '/master/blog/create/list/'
export const BLOG_DETAIL_URL = '/master/blog/detail/'



export const SLIDER_URL = '/master/slider/create/list/'
export const COUPON_URL = '/master/coupon/create/list/'

export const REVIEW_URL = '/master/review/create/list/'
export const CONTACT_US_URL = '/master/contact-us/'

export const CHECK_OUT_URL = '/master/check-out/create/list/'

export const CHANGE_PASSWORD_URL = '/master/user/change-password/'
export const USER_PROFILE_URL = '/master/user/detail/'


export const USER_URL = '/master/user/login/'
export const USER_SEND_OTP_URL = '/master/send-otp/'
export const USER_VERIFY_OTP_URL = '/master/verify-otp/'
export const USER_CHANGE_PASSWORD_URL = '/master/user/change-password/'


export const USER_REGISTER_URL = '/master/user/create/list/'
export const USER_ADD_SHIPPING_ADDRESS = '/master/user/add-shipping-address/'
export const USER_PROFILE_UPDATE = '/master/user/profile/update/'
export const USER_CHANGE_PASSWORD = '/master/user/change-password/'



export const USER_TOKEN_URL = '/api/token/'


export const CATEGORY_LOCATION_MAPING_URL = '/master/category/maping/location/'

export const PRIVACY_POLICY_URL = '/master/privacy-policy/create/list/'

export const FAQS_URL = '/master/faqs/create/list/'


export const ORDER_PLACE = '/master/user-order/create/list/'
export const OLD_ORDER_PLACE = '/master/user-order/single/list/detail/'


// user-order/single/list/detail/<int:pk>/</int:pk>